<template>
  <div style="transition: 0.4s;" class="w-1/4 bg-white rounded-xl space-y-6 p-6 tip-block" :class="`step${ nowStep }`">
    <img :src="require('@/assets/startips.png')" />
    <!-- <p>
      歡迎使用 AutoTurn 的行銷活動建立功能，是否需要系統為您進行簡單的教學導覽呢？
    </p> -->
    <p v-html="content"></p>
    <div class="tip-footer">
      <button
        v-if="nowStep === 0"
        class="hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 text-blue-800 transition duration-500 ease-in-out border-yellow-400 border-2 bg-yellow-300"
        @click="next()"
      >
        {{nextText}}
      </button>
      <button
        :style="{ opacity: nowStep === 0 ? 1 : 0 }"
        class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2 ml-4"
        :disabled="nowStep !== 0"
        @click="closeTips()"
      >
        {{closeTipsText}}
      </button>
    </div>
  </div>
</template>

<script>
import * as contentData from '@/components/Tips/startTips.json';

export default {
  name: 'StartTips',
  props: {
    nowStep: {
      type: Number,
      default: 1
    },
    selectLang: {
      type: String
    }
  },
  data() {
    return {
      nextText: '開始教學',
      closeTipsText: '跳過教學'
    }
  },
  computed: {
    content() {
      const data = contentData.default.filter(e => e.step === this.nowStep);
      let message;
      if (data.length > 0) {
        message = data[0].content_zh_TW;
        if(this.selectLang == 'zh-CN'){
          this.nextText = '开始教学';
          this.closeTipsText = '跳过教学';

          message = data[0].content_zh_CN;
        }
        if(this.selectLang == 'en-US'){
          this.nextText = 'start teaching';
          this.closeTipsText = 'skip teaching';

          message = data[0].content_en_US;
        }
      } else {
        message = '';
      }
      return message;
    }
  },
  methods: {
    next() {
      this.$emit('nextStep');
      // this.nowStep = this.nowStep + 1;
    },
    closeTips() {
      this.$emit('closeTips');
    }
  }
};

</script>

<style lang="scss" scoped>

img {
  margin: auto;
}

.step0 {
  position: absolute;
  top: 35vh;
  left: 35vw;
}

.tip-block {
  box-shadow: -4px -1px 15px 11px #333;
  z-index: 100;
}

.tip-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

</style>
